import React from 'react';
import { Group, Line, Text } from 'react-konva';
import { useEditorStore, CELL } from '../../store/editorStore';
import { useShallow } from 'zustand/react/shallow';

const MINOR_COLOR = '#1a2030';
const MAJOR_COLOR = '#222d40';
const MAJOR_EVERY = 5; // every 5 cells = major line

export const GridLayer: React.FC = () => {
  const { stageX, stageY, stageScale, stageW, stageH } = useEditorStore(useShallow(state => ({
    stageX: state.stageX, stageY: state.stageY, stageScale: state.stageScale, stageW: state.stageW, stageH: state.stageH
  })));

  // Don't render sub-pixel lines — LOD: hide minor grid when zoomed way out
  const showMinor = stageScale > 0.25;
  const showLabels = stageScale > 0.6;

  const startX = Math.floor(-stageX / stageScale / CELL) * CELL;
  const endX   = startX + stageW / stageScale + CELL * 2;
  const startY = Math.floor(-stageY / stageScale / CELL) * CELL;
  const endY   = startY + stageH / stageScale + CELL * 2;

  const lines: React.ReactNode[] = [];

  for (let x = startX; x <= endX; x += CELL) {
    const isMajor = Math.abs(Math.round(x / CELL)) % MAJOR_EVERY === 0;
    if (!showMinor && !isMajor) continue;
    lines.push(
      <Line
        key={`vx${x}`}
        points={[x, startY, x, endY]}
        stroke={isMajor ? MAJOR_COLOR : MINOR_COLOR}
        strokeWidth={(isMajor ? 2 : 1) / stageScale}
        listening={false}
      />
    );
    if (showLabels && isMajor) {
      lines.push(
        <Text
          key={`lx${x}`}
          x={x + 3 / stageScale}
          y={startY + 3 / stageScale}
          text={`${Math.round(x / 100 * 10) / 10}m`}
          fontSize={10 / stageScale}
          fill="#3a4a5a"
          listening={false}
        />
      );
    }
  }

  for (let y = startY; y <= endY; y += CELL) {
    const isMajor = Math.abs(Math.round(y / CELL)) % MAJOR_EVERY === 0;
    if (!showMinor && !isMajor) continue;
    lines.push(
      <Line
        key={`vy${y}`}
        points={[startX, y, endX, y]}
        stroke={isMajor ? MAJOR_COLOR : MINOR_COLOR}
        strokeWidth={(isMajor ? 2 : 1) / stageScale}
        listening={false}
      />
    );
  }

  return <Group listening={false}>{lines}</Group>;
};
